import React from "react";

import "./TermAndConditions.scss";

export default function TermAndConditions() {
  return (
    <div className="TAC__mainWrapper">
      <div className="TAC__contentWrapper">
        <h1>TERMS AND CONDITIONS OF USING A SCHOOL BUS</h1>
        <ol>
          <li>
            Reservation of seats is not allowed. Each student is entitled to one
            seat only, and bags are placed under the seat.
          </li>
          <li>
            Students are not allowed to change/remove clothes on the bus.{" "}
          </li>
          <li>
            Responsible use of devices/ electronic gadgets (e.g. tablet, iPad,
            laptop) onboard the bus.{" "}
          </li>
          <li>Pets are not allowed on the bus at all times.</li>
          <li>Parents are not permitted to ride on the school bus.</li>
          <li>
            Students will board and alight from the bus at pre-designated
            points, which are practical and safe. However, KAYE TRANSPORT
            SERVICE PTE LTD (KAYE) reserves the right to designate the pick-up /
            drop-off point in compliance with traffic and safety rules, size of
            the bus and road conditions.
          </li>
          <li>
            Students are not allowed to alight at non-designated points, other
            than their registered home address. For alternative stops, requests
            must be sent in writing by parents on behalf of their children and
            will be considered on a case-by-case basis and subject to space
            availability. No provision will be made should the child stay at an
            address with no existing bus service.
          </li>
          <li>
            When required by the school, parents/guardians must ensure that
            their child is met upon their arrival at the bus drop-off point. It
            is crucial that you are on time to meet your child as the bus cannot
            wait at any drop-off point or the driver may bring your child back
            to school and a flat fee of SGD 50.00 will be charged.
            Parents/guardians will then be notified to come and pick up their
            child from school.
          </li>
          <li>
            Parents cannot choose the bus size or what bus they would prefer as
            these are carefully planned by the professionals to fairly meet the
            needs of the community.
          </li>
          <li>
            All buses leave on time after school dismissal. KAYE and the school
            are not responsible for the transportation of students who have
            missed their buses as a result of their unpunctuality.
          </li>
          <li>
            If students do not arrive at the scheduled pick-up timing, Bus
            Captain will be allowed to wait 1 full minute, after that he will
            proceed to the next destination. Transport Office is not obligated
            to call the parents and reserves the rights to move on to the next
            destination without notice; hence parents have to arrange for their
            transport and no reimbursement will be provided.
          </li>
          <li>
            If the parents do not receive notice of the delay and the bus fails
            to arrive within 15 minutes of the scheduled pick-up time, the
            student may take a regular, non-premium taxi from a registered taxi
            company or use Standard/Economy Services from an app-based taxi
            company such as Grab, Uber, Ryde, TADA, GOJEK, or any other similar
            services. Reimbursements for one-way fare can be obtained from the
            Transport Office by submitting proof of payment within 4 weeks. (If
            there is no proof of payment, KAYE will estimate the amount to be
            claimed based on web-based services such as StreetDirectory.com).
          </li>
          <li>
            If your child/children do not require bus service for the following
            morning, please inform the Transport Office and the homeroom
            teacher via email the day before by 4pm.
          </li>
          <li>
            If students do not arrive at the schedule pick-up timing, Bus
            Captain will be allowed to proceed to the next destination.
            Transport Office is not obligated to call the parents and reserves
            the rights to move on to the next destination without notice; hence
            parents have to arrange for their transport and no reimbursement
            will be provided.
          </li>
          <li>
            If the parents do not receive notice for the delay and the bus fails
            to arrive within 15 minutes of the scheduled pick-up time, the
            student may take a regular, non-premium taxi from a registered taxi
            company or use Standard/Economy Services from an app-based taxi
            company such as Grab, Uber, Ryde, , TADA, GOJEK, or any other
            similar services. Reimbursements of one way fare can be obtained
            from the Transport Office by submitting proof of payment within 4
            weeks. (If there is no proof of payment, KAYE will estimate the
            amount to be claimed based on web-based services such as
            StreetDirectory.com).
          </li>
          <li>
            If your child/children do not require bus service for the following
            morning, please inform the Transport Office and the homeroom teacher
            via email the day before by 4pm.
          </li>
          <li>
            If your child/ children do not require bus service for the afternoon
            bus schedule for the day itself, please inform the Transport Office
            and the homeroom teacher via email by 12pm.
          </li>
          <li>
            All bus details given are subject to change to accommodate new
            students joining or change of address for existing students. Bus
            allocation is determined at the discretion of KAYE based on existing
            bus routes. Students may move from one bus to another to accommodate
            changes in pick-up routes, in which case Parents will be informed of
            the new bus numbers, pick-up and drop-off times.
          </li>
          <li>
            Damages/vandalism to seats or equipment on the bus must be paid for
            by the offender.
          </li>
          <li>
            Bus Application – A minimum of 2-weeks advance notice is required
            for all new applications. Late submission may result in the late
            commencement of bus service.
          </li>
          <li>
            Change of Residential Address – Parents must give Transport Office 2
            weeks’ notice in writing before the day of the move.
          </li>
          <li>
            Termination of Bus Services - Parents are required to give Transport
            Office 2 weeks’ notice in writing for termination of bus services.
          </li>
          <li>
            Any and all other terms and conditions specific to the school(s)
            your child(ren) attends.
          </li>
        </ol>

        <h1>CODE OF CONDUCT FOR SCHOOL BUS RIDERS</h1>
        <p>
          As a school bus rider, it is important to maintain a high standard of
          behaviour to ensure a safe and pleasant experience for yourself and
          your fellow riders. The following code of conduct outlines the
          expected behaviour while riding the bus:
        </p>
        <br />
        <ol type="1">
          <li>Respect for Others: </li>
          <ol type="i">
            <li>
              Treat fellow bus riders, bus drivers, and bus attendants with
              respect and courtesy.
            </li>
            <li>
              Do not engage in any form of bullying, teasing, or harassment.{" "}
            </li>
            <li>
              Use appropriate language and refrain from using profanity,
              derogatory remarks, or offensive gestures.
            </li>
          </ol>
          <li>Bus Safety</li>
          <ol type="i">
            <li>
              Follow all safety instructions and rules provided by the bus
              driver and bus attendant.
            </li>
            <li>
              Remain seated and fasten seatbelts while the bus is in motion.
            </li>
            <li>
              Avoid any behaviour that may distract the driver or jeopardise the
              safety of others.
            </li>
          </ol>
          <li>Personal Conduct</li>
          <ol type="i">
            <li>
              Behave in a manner that does not disrupt or endanger others.
            </li>
            <li>
              Do not engage in fighting, physical aggression, or any behaviour
              that may harm or intimidate others.
            </li>
            <li>
              Do not throw objects, vandalise or damage the bus, or any property
              belonging to others.
            </li>
            <li>Do not eat or drink aerated drinks or juices on the bus.</li>
            <li>Do not litter on the bus. </li>
          </ol>

          <li>Noise and Disturbance </li>
          <ol type="i">
            <li>
              Keep noise levels at an appropriate level to avoid disturbing other bus riders and the driver.
            </li>
            <li>
              Follow any additional guidelines provided by the bus driver or bus attendants regarding noise and disturbances.
            </li>
          </ol>
          <li>Personal Belongings </li>
          <ol type="i">
            <li>
              Take responsibility for your personal belongings and keep them secure during the bus journey.
            </li>
            <li>
              Do not bring prohibited items on the bus, such as weapons, drugs, alcohol, or any illegal substances.
            </li>
            <li>
              Respect the property of others and do not tamper with or steal personal belongings.
            </li>
          </ol>
          <li>Compliance with Rules and Regulations</li>
          <ol type="i">
            <li>
              Familiarise yourself with and adhere to all bus rules, policies,
              and regulations.
            </li>
            <li>
              Follow instructions given by the bus driver and bus attendants
              promptly and respectfully.
            </li>
            <li>
              Understand that violating the rules and regulations may result in
              disciplinary action or suspension from bus services.
            </li>
          </ol>
          <li>Arrival and Departure</li>
          <ol>
            <li>
              Arrive at the designated pickup point 5 minutes earlier and be ready to board the bus promptly.
            </li>
            <li>
              Wait in an orderly manner without pushing, shoving, or engaging in
              disruptive behaviour while boarding or exiting the bus.
            </li>
            <li>
              Follow any specific instructions provided by the bus driver or bus attendant regarding boarding procedures.
            </li>
          </ol>
          <br />
        </ol>
        <p>
          By following this code of conduct, you contribute to a positive and
          respectful bus environment. Failure to adhere to these guidelines may
          result in disciplinary action or the loss of bus privileges. Let us
          work together to ensure a safe and enjoyable bus journey for everyone.
        </p>
      </div>
    </div>
  );
}
